export const USAGE_TYPE_LABELS = {
  PRODUCT: 'Produto',
  TECH: 'Técnico',
  PUBLIC: 'Público',
  UNUSED: 'Não utilizado',
}

export const USAGE_TYPES = Object.keys(USAGE_TYPE_LABELS)

export const USAGE_TYPE_COLORS = {
  PRODUCT: 'primary',
  TECH: 'secondary',
  PUBLIC: 'success',
  UNUSED: 'default',
}
